import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Loader, EmptyState } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Mail, Building2, Phone, MessageSquare } from "lucide-react";

const STATUS_STYLE = { NEW: "bg-lime/40 text-forest", CONTACTED: "bg-psage text-forest", CLOSED: "bg-sgrey text-ink/60" };

export default function SalesRequests() {
  const [rows, setRows] = useState(null);
  const load = () => { setRows(null); api.get("/admin/sales-requests").then((r) => setRows(r.data)).catch(() => setRows([])); };
  useEffect(() => { load(); }, []);
  if (!rows) return <Loader />;

  async function setStatus(id, status) {
    try { await api.post(`/admin/sales-requests/${id}/status`, { data: { status } }); toast.success(`Marked ${status.toLowerCase()}`); load(); }
    catch (e) { toast.error(apiError(e)); }
  }

  return (
    <div className="space-y-5">
      <div><h1 className="font-heading text-2xl font-semibold text-forest">Sales Requests</h1>
        <p className="text-sm text-ink/60">Enterprise & custom-plan enquiries from your pricing page.</p></div>
      {rows.length === 0 ? <EmptyState title="No sales enquiries yet" hint="Enterprise 'Contact Sales' requests will land here." icon={Mail} /> : (
        <div className="grid gap-4 lg:grid-cols-2">
          {rows.map((r) => (
            <div key={r.id} data-testid={`sales-${r.id}`} className="rounded-xl border border-border bg-card p-5 shadow-sm">
              <div className="flex items-start justify-between">
                <div>
                  <p className="font-heading text-lg font-semibold text-forest">{r.company}</p>
                  <p className="text-sm text-ink/60">{r.name} · <span className="capitalize">{r.segment}</span>{r.plan_id ? ` · ${r.plan_id}` : ""}</p>
                </div>
                <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${STATUS_STYLE[r.status] || "bg-sgrey"}`}>{r.status}</span>
              </div>
              <div className="mt-3 space-y-1.5 text-sm text-ink/70">
                <p className="flex items-center gap-2"><Mail className="h-4 w-4 text-msage" /> {r.email}</p>
                <p className="flex items-center gap-2"><Phone className="h-4 w-4 text-msage" /> {r.phone}</p>
                {r.message && <p className="flex items-start gap-2"><MessageSquare className="mt-0.5 h-4 w-4 shrink-0 text-msage" /> {r.message}</p>}
                <p className="text-xs text-ink/40">{(r.created_at || "").slice(0, 16).replace("T", " ")}</p>
              </div>
              <div className="mt-4 flex gap-2">
                {r.status !== "CONTACTED" && <Button data-testid={`sales-contacted-${r.id}`} size="sm" className="bg-forest text-white hover:bg-forest/90" onClick={() => setStatus(r.id, "CONTACTED")}>Mark contacted</Button>}
                {r.status !== "CLOSED" && <Button data-testid={`sales-closed-${r.id}`} size="sm" variant="outline" className="border-border text-ink/60" onClick={() => setStatus(r.id, "CLOSED")}>Close</Button>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
